import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetRecentView = createAsyncThunk(
  "viewData/getRecentView",
  async (_, thunkAPI) => {
    try {
      const storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("loginData");
      const response = await axios.get(endPoint.GETRECENTVIEW, {
        headers: {
          sessionId: storedUuid ? storedUuid : "",
          Authorization: Token ? `Bearer ${Token}` : "",
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetRecentViewSlice = createSlice({
  name: "GetRecentData",
  initialState: {
    GetRecentData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetRecentView.fulfilled, (state, action) => {
        state.GetRecentData = action.payload;
      })
      .addCase(GetRecentView.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default GetRecentViewSlice.reducer;
